import React, { useEffect } from 'react';
import Switch from '@mui/material/Switch';

function CustomerToggle(props) {
  // const label = { componentsProps: { input: { 'aria-label': 'Demo switch' } } };
  const [checked, setChecked] = React.useState(false);

  useEffect(() => {
    if (props?.val === 'A') {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [props?.val]);

  const handleChange = event => {
    setChecked(event.target.checked);
    props.toogleItemStatus(event.target.checked);
  };

  return (
    <>
      <div className="flex flex-row items-center space-x-2">
        <div className="flex flex-row items-center space-x-3">
          <div className="font-semibold text-gray-700"> Status :</div>
          <div className={`${props?.val === 'A' ? 'text-green-500' : 'text-red-500'} font-medium`}>
            {props?.val === 'A' ? 'Active' : 'InActive'}
          </div>
        </div>
        <Switch checked={checked} onChange={handleChange} />
      </div>
    </>
  );
}

export default CustomerToggle;
